module.exports = __webpack_public_path__ + "static/media/Whiscash_gaussian2.a16fd41e.png";